import classNames from "classnames"
import { BackgroundDesignator } from "components/DesignSystem"
import { determineBackgroundClass } from "components/DesignSystemUtils/determineBackgroundClass"
import { PropsWithChildren } from "react"

export interface PaperBoxProps extends PropsWithChildren {
  /**
   *  The background color of the box.
   */
  background?: BackgroundDesignator
  /**
   *  Additional classes applied to the wrapper, e.g. padding or flex utilities
   *  added by composing components such as `Paper`.
   */
  className?: string
  /**
   *  Forwarded to the wrapper `<div>` for anchor/scroll-to targets.
   */
  id?: string
}

/**
 *  This is a component that presents a box with rounded corners and white
 *  background. We have another component, Paper, which does conceptually
 *  the same, but it adds additional flex, padding, and text alignment.
 *  In some cases we just need the box.
 *
 *  For layouts without the paper styling (no border), use SplitPanel directly.
 */
export function PaperBox({ background = "background/default", className, id, children }: PaperBoxProps) {
  const backgroundClass = determineBackgroundClass(background)
  return (
    <div
      id={id}
      className={classNames("rounded-2xl border border-gray-100 bg-clip-border", backgroundClass, className)}
    >
      {children}
    </div>
  )
}
